import { render, staticRenderFns } from "./GTextareaFormInput.vue?vue&type=template&id=03ba3231&scoped=true&"
import script from "./GTextareaFormInput.vue?vue&type=script&lang=ts&"
export * from "./GTextareaFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./GTextareaFormInput.vue?vue&type=style&index=0&id=03ba3231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ba3231",
  null
  
)

export default component.exports